import PropTypes from 'prop-types'

import UniversalLoginModal from '.'

const CheckoutButton = ({
  buttonText,
  canSubmit,
  className,
  handleError,
  url = window.location.href
}) => {

  return (
    <Choose>
      <When condition={canSubmit}>
        <UniversalLoginModal
          buttonText={buttonText}
          className={className}
          url={url}
        />
      </When>
      <Otherwise>
        <button
          className={className}
          data-testid='universal-login-button'
          onClick={handleError}
          type='button'
        >
          {buttonText}
        </button>
      </Otherwise>
    </Choose>
  )
}

CheckoutButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  canSubmit: PropTypes.bool.isRequired,
  className: PropTypes.string,
  handleError: PropTypes.func.isRequired,
  url: PropTypes.string
}

export default CheckoutButton
